export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    // status: 400,
    statusText: '',
    data: {
      serviceTypes: [
        {
          serviceTypeCd: 4,
          serviceTypeName: "directサイネージ系",
        },
        {
          serviceTypeCd: 3,
          serviceTypeName: "マンション・ホテル系",
        },
        {
          serviceTypeCd: 2,
          serviceTypeName: "hoam系",
        },
        {
          serviceTypeCd: 1,
          serviceTypeName: "コミュニティサポート系",
        }
      ]
      // errors: [
      //   // {
      //   //   code: "E1005",
      //   //   message: "{リクエストパラメータ名}の文字数は入力制限値を超えています"
      //   // },
      //   {
      //     code: "E4003",
      //     message: "アクセストークンの有効期限が切れました"
      //   }
      // ]
    }
  }
}